import { CommonService } from '@/services/common.service'
import { CallIoService } from '@/services/callio.service'

export default {
  getUserCallio({ commit }) {
    const crmUserId = JSON.parse(localStorage.getItem('userData')).userId
    return CallIoService.getUserCallIo({ crmUserId }).then(data =>
      localStorage.setItem('callioConfig', JSON.stringify(data.data))
    )
  },
  getConfigSystem({ commit }) {
    return CommonService.getConfigSystem()
      .then(data => commit('SET_CONFIG_SYSTEM', data))
      .catch(error =>
        commit('toast/NEW', { type: 'error', message: error.message }, { root: true })
      )
  },

  getConfigCCRP({ commit }) {
    return CommonService.getConfigCCRP()
      .then(data => commit('SET_CONFIG_CCRP', data))
      .catch(error =>
        commit('toast/NEW', { type: 'error', message: error.message }, { root: true })
      )
      .catch(error => console.error(error))
  },

  getConfigRegion({ commit }) {
    return CommonService.getConfigRegion()
      .then(data => commit('SET_CONFIG_REGION', data))
      .catch(error =>
        commit('toast/NEW', { type: 'error', message: error.message }, { root: true })
      )
      .catch(error => console.error(error))
  },
}
